import React, { FC } from 'react';
import { Button, useIsInIframe, X } from 'shared-components';

export const CloseIframeButtonStyled: FC<{
  version: 'white' | 'black';
  xProps?: React.SVGProps<SVGSVGElement> & { stroke?: string; pathProps?: React.SVGProps<SVGPathElement> };
}> = ({ version, xProps = {} }) => {
  const isOpenedInIframe = useIsInIframe();
  return isOpenedInIframe ? (
    <Button
      type="button"
      aria-label="Close"
      className="rounded-[9999px] bg-[#D8D8D8] border-[#9E9E9E] hover:bg-[#9E9E9E] w-[40px] h-[40px] p-0 m-0 flex items-center justify-center"
      onClick={() => {
        window.parent.postMessage(JSON.stringify({ type: 'close' }), '*');
      }}
    >
      <X
        width="40"
        height="40"
        pathProps={{
          fill: version === 'black' ? 'black' : 'white',
        }}
        {...xProps}
      />
    </Button>
  ) : null;
};
